import { t } from "@lingui/macro";
import { StaticImageData } from "next/image";
import React from "react";
import styled from "styled-components";
import { Stack } from "~/guidelines/Flex";
import SectionTitle from "~/guidelines/SectionTitle";
import ArlesApres from "../_assets/our-projects/arles-apres.png";
import ArlesAvant from "../_assets/our-projects/arles-avant.png";
import OrleansApres from "../_assets/our-projects/orlean-apres.png";
import OrleansAvant from "../_assets/our-projects/orlean-avant.png";
import TerrasseApres from "../_assets/our-projects/terrasse-apres.png";
import TerrasseAvant from "../_assets/our-projects/terrasse-avant.png";
import ToursApres from "../_assets/our-projects/tours-apres.png";
import ToursAvant from "../_assets/our-projects/tours-avant.png";
import OurProjectsDesktop from "./OurProjectsDesktop";
import OurProjectsMobile from "./OurProjectsMobile";

const Container = styled(Stack)`
  align-items: center;
  margin: ${({ theme }) => theme.spacing(7)} auto;
  width: 100%;
  max-width: 95vw;
  gap: ${({ theme }) => theme.spacing(6)};

  @media (min-width: 900px) {
    margin: ${({ theme }) => theme.spacing(13)} auto;
    gap: ${({ theme }) => theme.spacing(8)};
  }
`;

const DesktopOnly = styled.div`
  display: none;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: block;
  }
`;

const MobileOnly = styled.div`
  display: block;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: none;
  }
`;

interface ProjectData {
  id: string;
  label: string;
  beforeSrc: StaticImageData | string;
  afterSrc: StaticImageData | string;
}

const OurProjects = () => {
  const projectsData: ProjectData[] = [
    {
      id: "terrace-tours",
      label: t`Terrace in Tours`,
      beforeSrc: TerrasseAvant,
      afterSrc: TerrasseApres,
    },
    {
      id: "living-room-orleans",
      label: t`Living Room in Orleans`,
      beforeSrc: OrleansAvant,
      afterSrc: OrleansApres,
    },
    {
      id: "family-room-tours",
      label: t`Family Room in Tours`,
      beforeSrc: ToursAvant,
      afterSrc: ToursApres,
    },
    {
      id: "double-bedroom-arles",
      label: t`Double Bedroom in Arles`,
      beforeSrc: ArlesAvant,
      afterSrc: ArlesApres,
    },
  ];

  return (
    <Container>
      <SectionTitle
        variant="normal"
        firstPart={t`our_plural`}
        secondPart={t`Projects`}
        center="all"
      />

      <DesktopOnly>
        <OurProjectsDesktop projects={projectsData} />
      </DesktopOnly>

      <MobileOnly>
        <OurProjectsMobile projects={projectsData} />
      </MobileOnly>
    </Container>
  );
};

export default OurProjects;
